import { Css } from "@homebound/beam";
import { RuntimeStyle } from "@homebound/truss/runtime";

export function PdfCssReset() {
  return (
    <RuntimeStyle
      css={{
        html: Css.add("WebkitFontSmoothing", "antialiased").$,
        body: { ...Css.bgWhite.gray800.$, margin: "16px", fontSize: "14px !important", lineHeight: "20px !important" },
        "@media print": `
          body {
            margin: 0;
          }
        `,
      }}
    />
  );
}
